<template>
  <vx-card v-if="product.id">
    <!-- <router-link
      tag="div"
      class="vx-logo cursor-pointer"
      :to="{ name: 'detail-product', params: { productId: product.id } }"
    > -->
    <img
      :src="product.photos"
      alt="content-img"
      class="responsive card-img-top card-img-custom"
    />
    <br />
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-black">{{ limitCharTitle(product.name) }}</h4>

        <p class="text-black">Rp. {{ product.price }}</p>

        <p class="text-grey text-xs">{{ limitChar(product.description) }}</p>
      </span>
    </div>

    <vs-divider></vs-divider>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Stock</h4>
        <h5 class="text-grey text-xs">{{ product.stock }}</h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Weight</h4>
        <h5 class="text-grey text-xs">{{ product.weight }} gram</h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Preorder Duration</h4>
        <h5 class="text-grey text-xs">{{ product.preorder_duration }}</h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Limited order</h4>
        <h5 class="text-grey text-xs">{{ product.order_limit_count }}</h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Status</h4>
        <h5 class="text-grey text-xs">
          {{ setStatusProduct(product.status) }}
        </h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Sizes</h4>
        <h5 class="text-grey text-xs">
          {{ product.sizes.length != 0 ? product.sizes.join(",") : "--" }}
        </h5>
      </span>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <h4 class="text-sm">Colors</h4>
        <h5 class="text-grey text-xs">
          {{ product.colors.length != 0 ? product.colors.join(",") : "--" }}
        </h5>
      </span>
    </div>

    <div>
      <span>
        <h4 class="text-sm">Last Update</h4>
        <h5 class="text-xs text-grey">
          {{
            product.updated_at
              ? format_date(product.updated_at)
              : format_date(product.created_at)
          }}
        </h5>
      </span>
    </div>
    <div class="demo-alignment">
      <vs-button
        color="warning"
        type="filled"
        icon-pack="feather"
        icon="icon-edit"
        @click="editProduct(product.id)"
      ></vs-button>

      <vs-button
        type="filled"
        color="danger"
        icon-pack="feather"
        icon="icon-trash"
        @click="deleteAlert('danger', product.id)"
      ></vs-button>
    </div>
    <!-- </router-link> -->
  </vx-card>

  <vx-card class="overlay-card overflow-hidden" v-else>
    <template slot="no-body">
      <ads-vertical />
      <br />
    </template>
  </vx-card>
</template>

<script>
import moment from 'moment'
import axios from '../../../axios'
export default {
  props: ['product'],
  data() {
    return {
      card_7: {},
      deleteId: 0

    }
  },
  components: {


  },
  created() {

    // Card 7



  },
  methods: {
    updateIconChange() {
      if (this.is_like == 0) {
        this.is_like = 1
      } else {
        this.is_like = 0
      }
      const formData = {
        product_id: this.product.id,
        is_like: this.is_like
      }
      axios.product('/product_like', formData)
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            console.log(res)

          }
        })
        .catch(error => {
          console.log(error.response)

        })

    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    limitCharTitle(str) {
      var output = ''
      if (str.length > 15) {
        str = str.substring(0, 15)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    setStatusProduct(status) {
      if (status == 0) {
        return 'Normal'
      }
      if (status == 1) {
        return 'Preorder'
      }
      if (status == 2) {
        return 'Draft'
      }
      if (status == 3) {
        return 'Limited'
      }
    },
    getSize(arr) {
      return arr.join(',')
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id

      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deleteProduct
      })
    },

    deleteProduct() {
      console.log(`masuk delete${this.deleteId}`)

      axios.delete(`/ecommerce/web/product/${this.deleteId}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            console.log(res.data)
            this.$emit('update', this.deleteId)

          }


          this.$vs.notify({
            color: 'success',
            title: 'Berhasil!',
            text: 'Berhasil hapus job'
          })

        })
        .catch(error => {
          console.log(error.response)

        })


    },
    editProduct(id) {
      console.log(id)
      this.$router.push(`/product/edit/${id}`)
    },
  }

}
</script>

<style lang="stylus" scoped>
.card-img-custom {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>
